<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd10">

      <div id="search-land" >
        <h3 class="title">
          Tin của bạn
          <a v-if="!login_required" v-on:click="handleShowModal(null)">
            <i class="fas fa-pencil-alt"></i>
            Đăng tin
          </a>
        </h3>
        <div class="alert alert-warning" v-if="login_required">
          <p>Bạn cần <a v-on:click="login" >đăng nhập</a> để sử dụng chức năng này </p>
        </div>
        <div class="row" v-else>
          <div class="col-md-4">
            <p
              class="mobile-search-toggle visible-xs"
              v-on:click="hide_mobile = !hide_mobile"
            >
              {{ "Search" | translate }}
              <i class="fas fa-angle-down" v-if="hide_mobile"></i>
              <i class="fas fa-angle-up" v-if="!hide_mobile"></i>
            </p>
            <div
              class="search-controls mt10"
              v-bind:class="{ 'hidden-xs': hide_mobile }"
            >
              <div class="panel panel-default">
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form v-on:submit.prevent="doSearch">
                    <selectlocation
                      :item_class="'col-md-12 col-xs-12 col-sm-6'"
                      :province="search_params.province_id"
                      :district="search_params.district_id"
                      :commune="search_params.commune_id"
                      :is_required="false"
                      :is_get_location="false"
                      @updateLocation="updateLocation"
                    ></selectlocation>

                  
                      <div class="form-group">
                        <select
                          class="form-control"
                          v-model="search_params.approved"
                        >
                          
                          <option
                            v-for="item in approved_status"
                            :value="item.id"
                            :key="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group" v-if="search_params.approved == '1'">
                        <select
                          class="form-control"
                          v-model="search_params.status"
                        >
                          
                          <option
                            v-for="item in all_status"
                            :value="item.id"
                            :key="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    

                    <button
                          type="submit"
                          class="btn btn-success full-width"
                        >
                          <i class="fas fa-search"></i>
                          {{ "Search" | translate }}
                        </button>
                    
                  </form>
                </div>
                <!-- end panel-body -->
              </div>
            </div>
            <!-- end search controls -->
          </div>
          <div class="col-md-8">
            <div class="list-results">
              <loading
                class="mt10"
                :text="'Please wait' | translate"
                v-if="list_items === null"
              ></loading>
              <p
                class="mt10 alert alert-info"
                v-if="list_items && list_items.length == 0"
              >
                {{ "No result" | translate }}
              </p>
              <div v-if="list_items && list_items.length > 0">
                <div class="item" v-for="item in list_items" :key="item.id">
                  <div class="image">
                    <img
                      v-if="item.photos.length == 0"
                      src="static/images/no-photo.jpg"
                    />
                    <img v-else :src="item.photos[0].thumb_path" />
                    <div class="count">{{ item.photos.length }}</div>
                    <div class="mt10 text-success" v-if="item.approved" > <i class="fa-solid fa-check"></i> Đã duyệt</div>
                    <div class="mt10 text-warning" v-else > <i class="fa-solid fa-hourglass-start"></i> Chờ duyệt</div>
                  </div>
                  <div class="item-body">
                    <router-link
                      :to="{
                        name: 'AgriculturalAdDetail',
                        params: { id: item.id },
                      }"
                      >{{ item.user.name }}</router-link
                    >
                    <p>
                      <span v-if="item.unit_price" class="price"
                        >{{ toCommas(item.unit_price * 1000) }} </span
                      >đ/kg
                    </p>
                    <p class="mb5" >Sản lượng dự kiến: {{item.estimate_quantity}} tấn</p>
                    <p class="mb5">Ngày tuổi trái: {{item.growing_days}}</p>
                    <p class="mb5" v-if="item.approved" >Trạng thái: 
                      <span class="text-danger" v-if="item.status == 2">{{item.status_name}}</span>
                      <span class="text-success" v-else>{{item.status_name}}</span>
                    </p>
                    <p class="address"><i class="fas fa-map-marker-alt"></i> {{ item.full_address }}</p>
                    <!-- <div class="meta">
                      <p>{{ item.created_at | moment("from", "now") }}</p>
                    </div> -->
                  </div>
                  <div class="wrap-dropdown">
                    <mydropdown :ref="item.refDropdown">
                      <div slot="button">
                        <span
                          class="dropdown-toggle pd5"
                          data-toggle="dropdown"
                          v-on:click="$refs[item.refDropdown][0].toogle()"
                        >
                          <i class="fas fa-ellipsis-h fa-lg"></i>
                        </span>
                      </div>
                      <ul slot="body" class="dropdown-menu dropdown-menu-right">
                        <li v-on:click="copyLink(item)">
                          <a>
                            <i class="far fa-copy"></i>
                            {{ "Copy link" | translate }}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="updateItem(item)">
                            <i class="fas fa-edit"></i>
                            {{ "Update" | translate }}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="removeAd(item)">
                            <i class="fas fa-times"></i>
                            {{ "Remove" | translate }}
                          </a>
                        </li>
                      </ul>
                    </mydropdown>
                  </div>
                </div>
                <!-- end .item  -->
                <paginate
                  v-if="total_page > 1"
                  :page-count="total_page"
                  :click-handler="clickPage"
                  :prev-text="'Prev' | translate"
                  :next-text="'Next' | translate"
                  v-model="page"
                  :container-class="'pagination'"
                ></paginate>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end search-land -->
      <div v-if="show_form">
        <form-agricultural-ad
          ref="formLand"
          :pass_data="pass_data"
          @modalData="modalData"
        ></form-agricultural-ad>
      </div>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Paginate from 'vuejs-paginate'
import Loading from '@/components/elements/Loading'
import FormAgriculturalAd from '@/components/AgriculturalAd/FormAgriculturalAd'
import mydropdown from 'vue2-bootstrap-dropdown'
import selectlocation from '@/components/elements/SelectLocation'
export default {
  name: 'FindLand',
  components: {
    MyHeader,
    Paginate,
    Loading,
    FormAgriculturalAd,
    mydropdown,
    selectlocation
  },
  data () {
    return {
      user: null,
      list_items: null,
      hide_mobile: true,
      variants: [],
      page: 1,
      total_page: 1,
      show_form: false,
      pass_data: null,
      approved_status: [
        { id: '', name: 'Tình trạng duyệt (tất cả)' },
        { id: '0', name: 'Chưa duyệt' },
        { id: '1', name: 'Đã duyệt' },
      ],
      all_status: [
        { id: '', name: 'Tình trạng bán (tất cả)' },
        { id: '1', name: 'Đang bán' },
        { id: '2', name: 'Đã bán' },
      ],
      login_required: false,
      search_params: {
        is_my_post: true,
        approved: '',
        status: '',
        type_id: '',
        keyword: '',
        limit: Utils.getLimit(),
        province_id: '',
        district_id: '',
        commune_id: '',
        page: 1,
      }
    }
  },
  methods: {
    login(){
      window.REQUIRE_LOGIN_ROUTE_NAME = 'MyAgriculturalAds' // set callback after login
      this.$router.push({ name: 'Login' })
    },
    copyLink (item) {
      let str = Utils.getBaseUrl() + `/agricultural-ads/${item.id}`
      Utils.sendToClipboard(str)
      this.$alertify.success(this.$t('Copied link'))
    },
    updateItem (item) {
      this.showModal(item)
    },
    removeAd (item) {
      this.$alertify.confirmWithTitle(
        this.$t('Confirm'),
        this.$t('Are you sure to remove this ad ?'),
        () => {
          Utils.requestV2(this, true)
            .delete(`/agricultural-ads/${item.id}`)
            .then((response) => {
              this.doSearch()
            })
        }
      )
    },
    handleShowModal () {
      if (this.user) {
        this.showModal(null)
      } else {
        this.$router.push({
          name: 'Login'
        })
        // Utils.showLoginZalo()
      }
    },
    showModal (data) {
      // console.log(data)
      // if (!data) {
      //   return this.$alertify.alertWithTitle(
      //     this.$t('Confirm'),
      //     this.$t('You need to update your phone to use this function')
      //   )
      // }
      this.show_form = false

      setTimeout(() => {
        this.show_form = true
        this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data

        setTimeout(() => {
          this.$refs.formLand.open()
        })
      })
    },
    updateLocation (data) {
      console.log('data', data)
      for (let key in data) {
        this.search_params[key] = data[key]
      }
    },
    changeType (typeId) {
      this.search_params.type_id = typeId
      this.doSearch()
    },

    doSearch () {
      this.search_params.page = this.page
      this.search()
    },
    modalData (data) {
      // console.log('data', data)
      this.doSearch()
    },
    search () {
      this.list_items = null
      let search_params = this.search_params
      if (search_params.approved == ''){
        search_params.status = '';
      }
      Utils.requestV2(this, true)
        .get(
          `/agricultural-ads/?${Utils.arrayToRequestParam(search_params)}`
        )
        .then((response) => {
          let data = response.data

          let list = data.data
          list = list.map((item) => {
            item.refDropdown = 'dropdown' + item.id
            return item
          })
          this.list_items = list
          this.total_page = Utils.getTotalPages(data.total)
        })
        .catch((error) => {
          console.log('error',error)
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    toCommas (value) {
      return Utils.toCommas(value)
    },
    clickPage (pageNum) {
      this.search_params.page = pageNum
      this.search()
    }
  },
  mounted () {
    this.user = Utils.getUser(this)
    if (!this.user){
      this.login_required = true
    }else{
      this.search()
    }
    
    
  }
}
</script>

<style>
.search-controls .select-location-element label {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AgriculturalAd/MyAgriculturalAds.vue